import React, { useEffect, useMemo, useRef, useState, useCallback, memo } from "react";
import SflLogo from "../assets/ui_revamp/SFL.svg";
import LoadingPaperplane from "../assets/ui_revamp/Loading-paperplane.json";
import { Flex, Typography } from "antd";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";

let data = [
  {
    type: 0,
    title: "Verifying information...",
  },
  {
    type: 1,
    title: "Getting the model info...",
  },
  {
    type: 2,
    title: "Getting the model ready...",
  },
  {
    type: 3,
    title: "Stay on the screen...",
  },
  {
    type: 4,
    title: "Patience is the key to success...",
  },
  {
    type: 5,
    title: "We are almost there...",
  },
  {
    type: 6,
    title: "Redirecting to designer tool...",
  },
  {
    type: 7,
    title: "Generating Dxf...",
  },
];

const TEXT_CYCLE_INTERVAL_MS = 4000;
const MAX_LOTTIE_DPR = 1.5;

const getLottieDpr = () => {
  if (typeof window === "undefined") {
    return 1;
  }
  const deviceDpr = window.devicePixelRatio || 1;
  return Math.min(deviceDpr, MAX_LOTTIE_DPR);
};

const LottiePlayer = memo(function LottiePlayer({ lottieRef, rendererSettings, onDomLoaded }) {
  return (
    <Lottie
      animationData={LoadingPaperplane}
      loop
      autoplay
      renderer="canvas"
      lottieRef={lottieRef}
      rendererSettings={rendererSettings}
      onDOMLoaded={onDomLoaded}
      className="loading-lottie"
    />
  );
});

const LoadingScreen = ({ informationChecked, type }) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const lottieRef = useRef(null);
  const intervalRef = useRef(null);

  const rendererSettings = useMemo(
    () => ({
      preserveAspectRatio: "xMidYMid meet",
      progressiveLoad: true,
      clearCanvas: true,
      dpr: getLottieDpr(),
    }),
    []
  );

  const clearTextInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    clearTextInterval();

    if (type !== undefined) {
      setCurrentTextIndex(7);
      return;
    }

    if (informationChecked == null) {
      return;
    }

    setCurrentTextIndex((prevIndex) => (prevIndex + 1) % data.length);
    intervalRef.current = setInterval(() => {
      setCurrentTextIndex((prevIndex) => {
        if (prevIndex === 6) {
          clearTextInterval();
          return prevIndex;
        }
        return (prevIndex + 1) % data.length;
      });
    }, TEXT_CYCLE_INTERVAL_MS);

    return () => clearTextInterval();
  }, [clearTextInterval, informationChecked, type]);

  const handleLottieDomLoaded = useCallback(() => {
    if (lottieRef.current) {
      lottieRef.current.setSubframe(false);
    }
  }, []);

  return (
    <Flex justify="center" align="center" className="h-100 loading-screen" vertical>
      <img
        src={SflLogo}
        alt="SFL Logo"
        className="loading-sfl-logo"
      />
      <LottiePlayer
        lottieRef={lottieRef}
        rendererSettings={rendererSettings}
        onDomLoaded={handleLottieDomLoaded}
      />
      {data[currentTextIndex] && (
        <Typography.Title level={2} className="loading-status-text">
          {data[currentTextIndex].title}
        </Typography.Title>
      )}
      <Link to={"/"} className="loading-back-button" style={{ color: "#FFFFFF" }}>
        Back to CRM
      </Link>
      <Typography.Text className="loading-footer">
        @SightFlight Team
      </Typography.Text>
      <Typography.Text className="loading-description">
        SightFlight creates high-end roofing and solar software tools that aim to
        manage projects easier than before.
      </Typography.Text>
    </Flex>
  );
};

export default LoadingScreen;
